/*
 * Single source of truth for the research articles.
 *
 * Ordered newest first. The listing pages render all of them in this order,
 * and the nav dropdown renders NAV_COUNT from the top, so publishing an
 * article means adding it here at position 0 and nothing else.
 *
 * navTitle / navDesc are the shorter forms the nav card needs; they fall back
 * to title / desc.
 */

import shieldImg from '../../assets/ShieldCheckered.png';
import purpleShieldImg from '../../assets/purpleshield.png';
import policyImg from '../../assets/policy.png';
import binocularsImg from '../../assets/binoculars.png';
import complianceImg from '../../assets/compliance.png';
import detectiveImg from '../../assets/Detective.png';
import claudeCardImg from '../../assets/tools/anthropic.png';
import mcpCardImg from '../../assets/tools/mcp_white.png';

export const NAV_COUNT = 4;

export const resourceCards = [
  {
    slug: 'app-mcp-connections',
    category: 'Research',
    title: 'The Connection Layer Is Where Enterprise AI Risk Moved',
    desc: 'App and MCP connections create standing, delegated access to company systems, and no CASB, DLP or prompt monitor sees them being made. The adoption and vulnerability data, the DORA and NIS2 exposure, and what Bltz now detects across ChatGPT, Claude and Gemini.',
    navTitle: 'Where Enterprise AI Risk Moved',
    navDesc: 'App and MCP connections hand AI standing access to company systems, and no CASB or DLP sees them being made.',
    tag: 'MCP',
    img: mcpCardImg,
  },
  {
    slug: 'coding-agents',
    category: 'Guide',
    title: '10 Claude Code Risks Your Security Stack Cannot See',
    desc: 'Coding agents read your secrets, write your code and run your shell, with no network appliance in the path. Ten advanced risks, and why existing controls miss each one.',
    navTitle: '10 Coding Agent Risks You Cannot See',
    navDesc: 'Coding agents read your secrets, write your code and run your shell, with no network appliance in the path.',
    tag: 'Coding Agents',
    img: claudeCardImg,
  },
  {
    slug: 'ai-security-best-practices',
    category: 'Blog',
    title: 'AI Security Best Practices for Enterprise',
    desc: 'Learn the key strategies for securing AI systems at scale, from prompt injection prevention to model access controls.',
    navTitle: 'AI Security Best Practices',
    navDesc: 'Key strategies for securing AI systems at scale, from prompt injection prevention to model access controls.',
    tag: 'AI Security',
    img: shieldImg,
  },
  {
    slug: 'purple-team-testing',
    category: 'Blog',
    title: 'Why Red Teaming Alone Isn’t Enough',
    desc: 'Discover why continuous purple team testing, combining offensive and defensive AI agents, is essential for production AI.',
    navTitle: 'Why Red Teaming Isn’t Enough',
    navDesc: 'Continuous purple team testing with offensive and defensive AI agents for production AI.',
    tag: 'Purple Team',
    img: purpleShieldImg,
  },
  {
    slug: 'ciso-ai-governance',
    category: 'Whitepaper',
    title: 'The CISO’s Guide to AI Governance',
    desc: 'A comprehensive framework for CISOs to establish AI governance policies, manage shadow AI risks, and meet compliance requirements.',
    navTitle: 'CISO’s Guide to AI Governance',
    navDesc: 'A framework for CISOs to establish AI governance policies and manage shadow AI risks.',
    tag: 'Governance',
    img: policyImg,
  },
  {
    slug: 'fortune-500-ai-security',
    category: 'Case Study',
    title: 'Fortune 500 Bank Secures AI Copilots',
    desc: 'How a major financial institution used Bltz to discover and monitor 200+ AI systems across their organization.',
    navTitle: 'Fortune 500 Bank Secures AI',
    navDesc: 'How a major financial institution discovered and monitored 200+ AI systems with Bltz.',
    tag: 'Case Study',
    img: binocularsImg,
  },
  {
    slug: 'ai-compliance-frameworks',
    category: 'Whitepaper',
    title: 'ISO 42001 & NIST AI RMF Compliance',
    desc: 'Step-by-step guide to achieving AI compliance with ISO 42001, NIST AI RMF, and SOC 2 using automated governance tooling.',
    navTitle: 'ISO 42001 & NIST Compliance',
    navDesc: 'Achieving AI compliance with ISO 42001, NIST AI RMF and SOC 2 using automated governance tooling.',
    tag: 'Compliance',
    img: complianceImg,
  },
  {
    slug: 'detecting-shadow-ai',
    category: 'Blog',
    title: 'Detecting Shadow AI in the Enterprise',
    desc: 'Practical approaches to identifying unsanctioned AI applications before sensitive data is exposed to unauthorized models.',
    navTitle: 'Detecting Shadow AI',
    navDesc: 'Identifying unsanctioned AI applications before sensitive data reaches unauthorized models.',
    tag: 'Shadow AI',
    img: detectiveImg,
  },
];

/* 'Case Study' -> 'case-study', for the badge modifier class. */
export const categorySlug = (category) =>
  (category || '').toLowerCase().replace(/\s+/g, '-');

/* The newest few, for the nav dropdown and the mobile drawer. */
export const latestResources = resourceCards.slice(0, NAV_COUNT);

export default resourceCards;
